module.exports = __webpack_public_path__ + "img/model_x_selection.f53159c9.jpg";